import(/* webpackMode: "eager", webpackExports: ["SilentBoundary"] */ "/app/components/error/silent-boundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FloatingActivityRail"] */ "/app/components/floating-activity/floating-activity-rail.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ArbBuilderDialogHost"] */ "/app/features/arb/components/arb-builder-dialog-host.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AssistantPanel"] */ "/app/features/assistant/components/assistant-panel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TradeSidePanel"] */ "/app/features/dashboard/components/trade-side-panel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HedgeBuilderDialogHost"] */ "/app/features/hedge/components/hedge-builder-dialog-host.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ResearchSupervisor"] */ "/app/features/order/research/research-supervisor.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AccountDataManager"] */ "/app/service/ws/account-data-manager.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ActiveOrdersSync","ActiveTradesSync"] */ "/app/service/ws/account-orders-sync.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ActivePositionsSync"] */ "/app/service/ws/account-positions-sync.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ActiveAccountSnapshotSync"] */ "/app/service/ws/account-snapshot-sync.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NotificationManager"] */ "/app/service/ws/notification-manager.tsx");
